// TODO: merge this into studio.ts file in dashboard-api

import _ from 'lodash';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { ICompleteAttemptBody } from '@scale/shared/types/api/complete';
import { ILabelerJson } from '@scale/shared/types/user';

// posts

export async function addOrCreateLabelerGroup(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/groups/add_or_create_labeler_group`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function signup(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/registerNext`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function updateUser(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/user/update`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function enableStudio(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/enable_studio`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function login(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/loginNext`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function resetPasswordSendEmail(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/reset_password/send_email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function resetPassword(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/reset_password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function skipTask(body: ICompleteAttemptBody) {
  const updatedResponse = await apiFetch(null, `internal/complete_studio/quarantine`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return updatedResponse;
}

export async function sendBackToQueue(body: $FIXME) {
  const updatedResponse = await apiFetch(null, `internal/complete_studio/unquarantine`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return updatedResponse;
}

export async function submitTaskAttempt(taskType: string, body: ICompleteAttemptBody) {
  const updatedResponse = await apiFetch(null, `internal/complete_studio/${taskType}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return updatedResponse;
}

export async function submitTaskReview(taskType: string, body: ICompleteAttemptBody) {
  const updatedResponse = await apiFetch(null, `internal/complete_studio/review/${taskType}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return updatedResponse;
}

export async function uploadGroundMeshEditsBeforeSubmit(params: {
  groundMeshEdits?: [number, number][];
  subtaskId?: string;
}) {
  return await apiFetch(null, `internal/labeling/upload_ground_mesh_edits_before_submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function submitTrainingAttempt(
  taskType: string,
  trainingAttempt: string,
  body: $FIXME,
) {
  const updatedResponse = await apiFetch(
    null,
    `internal/training/complete/${taskType}/${trainingAttempt}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
  return updatedResponse;
}

export async function removeAssignments(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/remove_assignments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function addAssignments(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/add_assignments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function batchAssignments(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/batch_assignments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function ensureAdminProjectPermissions(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/ensure_admin_permissions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function removeClaims(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/remove_claims`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function addClaims(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/add_claims`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function updateProjectPermissionsStatus(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/update_permission_status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function updateProjectTrustedTaskerStatus(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/update_trusted_status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function beginCourse(courseId: string, projectId?: string) {
  return await apiFetch(null, `internal/courses/${courseId}/begin/`, {
    method: 'POST',
    body: JSON.stringify({ projectId }),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function continueCourse(courseId: string, body?: Record<any, any>) {
  return await apiFetch(null, `internal/courses/${courseId}/continue/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function rateCourse(progressId: string, body?: Record<any, any>) {
  return await apiFetch(null, `internal/courses/${progressId}/rate/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function screenCourseResume(courseId: string, body?: Record<any, any>) {
  return await apiFetch(null, `internal/courses/${courseId}/screen_resume/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function certificationTimeRemainingSecsSync(
  courseProgressId: string,
  certificationTimeRemainingSecs: number,
) {
  return await apiFetch(
    null,
    `internal/courses/${courseProgressId}/certificationTimeRemainingSecsSync`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ certificationTimeRemainingSecs }),
    },
  );
}

export async function updateRemainingTimeCourses(courseProgressId: string, remainingTime: number) {
  return await apiFetch(null, `internal/coursesV2/${courseProgressId}/updateRemainingTime`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ remainingTime }),
  });
}

export async function ensureShadowWorker() {
  return await apiFetch(null, `internal/labeling/ensure_shadow_worker`, {});
}

export async function checkCourseAnswer(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/courses/checkAnswer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function getCourseAnswers(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/courses/getAnswers`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

// cancel task in studio comments queue
export async function cancelTask(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/cancel_task`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

// change which labeling groups are assigned to a batch
export async function editBatchGroupAssignment(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/groups/edit_batch_group_assignment`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

// updates response with comments for studio but doesn't send back to queue
export async function updateResponseWithComments(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/update_response_with_comments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

// send back to queue with comments for studio
export async function sendBackToQueueWithComments(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/send_back_to_queue_with_comments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

// resolves comments for benchmarks in studio
export async function resolveBenchmarkComments(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/resolve_benchmark_comments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function exportLabelerData(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/labelers/export_labeler_data`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

// gets
export async function fetchBatchLabelerGroups(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/groups/fetch_batch_labeler_groups`, { query });
}

export async function fetchSingletonGroups(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/groups/fetch_singleton_groups`, { query });
}

export async function fetchGroupMembers(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/groups/fetch_group_members`, { query });
}

export async function getIsStudioProject(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/is_studio_project`, { query });
}

export async function fetchGroups(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/groups/fetch_groups`, { query });
}

export async function getResetPasswordTokenValidity(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/reset_password/validate_token`, { query });
}

export async function fetchTaskById(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/benchmarks/tasks`, { query });
}

export async function getCourse(permissionId: string) {
  return await apiFetch(null, `internal/courses/${permissionId}/details/`, {});
}

export async function fetchLabelers(params: $FIXME): Promise<{ labelers: ILabelerJson[] }> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/labelers`, { query });
}

export async function fetchLabelersForProject(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/labelers_for_project`, { query });
}

export async function fetchMetricsForProject(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/metrics_for_project`, { query });
}

export async function fetchMetricsForAllProjects(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/metrics_for_all_projects`, { query });
}

export async function fetchTaskThroughputByDay(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/metrics/tasks_throughput_by_day`, { query });
}

export async function fetchAnnotationThroughputByDay(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/metrics/annotations_throughput_by_day`, {
    query,
  });
}

export async function fetchAttemptsPerTasker(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/metrics/attempts_per_tasker`, { query });
}

export async function fetchEvaluationTaskAccuracyByDay(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/metrics/evaluation_task_accuracy_by_day`, {
    query,
  });
}

export async function fetchEvaluationTaskAccuracyByWorker(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/metrics/evaluation_task_accuracy_by_worker`, {
    query,
  });
}

export async function fetchTimePerAttemptByField(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/metrics/time_per_attempt_by_field`, {
    query,
  });
}

export async function getAssignmentFromQueue(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/labeling/tasks/get_task_from_queue`, { query });
}

export async function getProjectsForShadowTasker(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/labeling/get_projects_dashboard_info`, { query });
}

export async function getTaskerActivity(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, 'internal/scaler/activity', { query });
}

export async function beginTrainingScenario(trainingId: string, retry?: boolean) {
  return await apiFetch(null, `internal/training/begin/${trainingId}`, { query: { retry } });
}

export async function pollTrainingAttempt(trainingAttempt: string) {
  return await apiFetch(null, `internal/training/fetch/${trainingAttempt}`, {});
}

export async function getTrainingScenarioStatus(trainingScenario: string) {
  return await apiFetch(null, `internal/training/status/${trainingScenario}`, {});
}

export async function getCourseProgress(courseId: string) {
  return await apiFetch(null, `internal/courses/${courseId}`, {});
}

export async function getTaskerTaskLogFromCustomerDashboard(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/per_tasker_task_log_for_customer`, { query });
}

export async function getTaskerTaskLog(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/labeling/per_tasker_task_log`, { query });
}

export async function getLastResponseByAttempt(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/labeling/last_response_by_attempt`, { query });
}

export async function getPermissioningHistory(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/labeling/permissioning_history`, { query });
}
export async function getTaskerMetrics(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/labeling/get_tasker_metrics`, { query });
}
export async function getProjectsDashboardInfo(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/labeling/get_projects_dashboard_info`, { query });
}

export async function getCourseInfo(name: string) {
  return await apiFetch(null, `internal/courses/${name}`, {});
}

export async function getCourseV2Info(id: string) {
  return await apiFetch(null, `internal/coursesV2/getCourse/${id}`, {});
}

export async function getCourseV2UserPermission(userId: string, courseId: string) {
  return await apiFetch(null, `internal/coursesV2/hasPermission`, {
    query: { userId, courseId },
  });
}

export async function getCourseRatings(id: string) {
  return await apiFetch(null, `internal/courses/rating/${id}`, {});
}

export async function getCourseV2Ratings(id: string) {
  return await apiFetch(null, `internal/coursesV2/rating/${id}`, {});
}

export async function getCourseFeedback(id: string, rating: number) {
  return await apiFetch(null, `internal/courses/feedback/${id}`, { query: { rating } });
}

export async function getCourseV2Feedback(id: string, rating: number) {
  return await apiFetch(null, `internal/coursesV2/feedback/${id}`, { query: { rating } });
}

export async function getStudioCommentsQueueInfo(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, 'internal/self_serve/get_studio_comments_queue_info', { query });
}

export async function fetchExportLabelerDataS3(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/labelers/export_labeler_data_s3`, { query });
}

// used to render dummy attempt for studio comments queue
export async function fetchTaskForDummyAttempt(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/fetch_task_for_dummy_attempt`, {
    query,
  });
}

export async function beginCourseV2(
  courseId: string,
  startNewAttempt?: boolean,
  projectId?: string,
) {
  return await apiFetch(null, `internal/coursesV2/${courseId}/begin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ startNewAttempt, projectId }),
  });
}
export async function continueCourseV2(progressId: string, body?: Record<any, any>) {
  return await apiFetch(null, `internal/coursesV2/${progressId}/continue`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function checkCourseV2Answer(courseId: string, body?: Record<any, any>) {
  return await apiFetch(null, `internal/coursesV2/${courseId}/checkAnswer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function recordCourseV2TextResponse(courseId: string, body?: Record<any, any>) {
  return await apiFetch(null, `internal/coursesV2/${courseId}/recordTextResponse`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function recordCourseV2AudioResponse(courseId: string, body?: Record<any, any>) {
  return await apiFetch(null, `internal/coursesV2/${courseId}/recordAudioResponse`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function rateCourseV2(progressId: string, body?: Record<any, any>) {
  return await apiFetch(null, `internal/coursesV2/${progressId}/rate/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function submitBenchmarkAccuracyV2(courseId: string, body: Record<any, any>) {
  return await apiFetch(null, `internal/coursesV2/${courseId}/submitBenchmarkAccuracy`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}
